import React from "react"
import { FaExternalLinkAlt } from "react-icons/fa"
import { Section } from "./section"
import Columns from "../layout/columns"
import Column from "../layout/column"
import Seo from "../seo"
import Markdown from "../unitary/markdown"

// @ts-ignore
import {opgAzureBlue, opgElementSpacing} from "../../styles/opg-variables.module.scss"

function pxToInt(px) {
  return parseInt(px.replace("px", ""))
}

function recordDownload(filename) {
  // @ts-ignore
  if (typeof window.gtag !== `function`) {
    return false
  }

  // @ts-ignore
  window.gtag("event", "select_content", { content_type: filename })
}

function HeaderTitleAndSubtitle(props) {
  return (
    <Column classes={["has-text-centered"]}>
      <h1 className="is-size-3 has-text-weight-medium">{props.header.title}</h1>
      {props.header.subtitle && (
        <h2 className="is-size-6 has-text-weight-medium content opg-subtitle">
          <Markdown input={props.header.subtitle} />
        </h2>
      )}
    </Column>
  )
}

const headerButtonStyles = {
  backgroundColor: opgAzureBlue,
  color: "white",
  borderColor: "white",
  borderWidth: "1px",
  borderStyle: "solid",
}

function HeaderButtonDownload(props) {
  const filename = props.download_filename
  if (filename) {
    return (
      <a
        className="button"
        href={`/pdfs/${filename}`}
        download={filename}
        onClick={() => {
          return recordDownload(filename)
        }}
        style={headerButtonStyles}
      >
        <span>Download</span>
      </a>
    )
  } else {
    return null
  }
}

function HeaderButtonComment(props) {
  const linked_in_post_link = props.linked_in_post_link
  if (linked_in_post_link) {
    return (
      <a
        className="button"
        href={linked_in_post_link}
        target="_blank"
        rel="noreferrer"
        style={headerButtonStyles}
      >
        <span>Comment</span>
        <span className="icon" style={{ color: "white" }}>
          <FaExternalLinkAlt />
        </span>
      </a>
    )
  } else {
    return null
  }
}

function HeaderButtons(props) {
  if (props.header.download_filename || props.header.linked_in_post_link) {
    return (
      <div className={`buttons ${props.class}`} style={props.style}>
        <HeaderButtonDownload {...props.header} />
        <HeaderButtonComment {...props.header} />
      </div>
    )
  } else {
    return null
  }
}

function datesToString(createdAt, updatedAt) {
  if (!createdAt && !updatedAt) {
    return ""
  }

  const date = new Date(updatedAt || createdAt)

  const prefix = updatedAt ? "Updated " : ""

  return `${prefix}${date.toLocaleString("default", {
    month: "short",
  })} ${date.toLocaleString("default", { year: "numeric" })}`
}

function HeaderInner(props) {
  const columnClasses = [
    "is-3",
    "is-hidden-mobile",
    "is-hidden-tablet-only",
    "is-hidden-desktop-only",
  ]

  const marginTop = `${pxToInt(opgElementSpacing) * 2}px`
  return (
    <div>
      <Columns
        classes={["is-vcentered"]}
        style={{ marginBottom: `-${opgElementSpacing}` }}
      >
        <Column classes={columnClasses}>
          {datesToString(props.header.created_at, props.header.updated_at)}
        </Column>
        <HeaderTitleAndSubtitle header={props.header} />
        <Column classes={columnClasses}>
          <HeaderButtons class="is-right" header={props.header} />
        </Column>
      </Columns>
      <HeaderButtons
        class="is-centered is-hidden-widescreen"
        header={props.header}
        style={{ marginTop: marginTop }}
      />
    </div>
  )
}

export default function Header(props) {
  return (
    <Section>
      <Seo
        title={props.title}
        description={props.description}
        thumbnail_name={props.thumbnail_name}
      />
      <div
        className="box"
        style={{
          backgroundColor: opgAzureBlue,
          boxShadow: "none",
          color: "white",
        }}
      >
        <HeaderInner header={props} />
      </div>
    </Section>
  )
}
